import { RawUserInfo } from "./RawUserInfo";


export class UserLocalStorage
{
    public Save(userInfo: RawUserInfo): void
    {           
        try
        {
            window.localStorage.setItem('user', JSON.stringify(userInfo));
        }
        catch (ex: any)
        {
            console.warn(`Storing user info to local storage problem: ${ex.message}`);
        }
    }

    public Delete(): void
    {
        window.localStorage.removeItem('user');
    }

    public get IsUserAvailable(): boolean
    {
        const raw = window.localStorage.getItem('user');

        return raw != null;
    }

    public get User(): RawUserInfo
    {
        const rawString = window.localStorage.getItem('user');
        const raw = JSON.parse(rawString || "");

        return raw;
    }
}
